import React from 'react';
import PropTypes from 'prop-types';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';

function EditButton({ website, editWebsite, onDelete }) {
  return (
    <SplitButton
      title="Edit"
      key={website.id}
      id={`split-button-basic-group-${website.id}`}
      onClick={() => {
        editWebsite(website.id);
      }}
    >
      <DeleteButton website={website} onDelete={onDelete} />
    </SplitButton>
  );
}

EditButton.propTypes = {
  website: PropTypes.object,
  editWebsite: PropTypes.func,
  onDelete: PropTypes.func,
};

export default EditButton;
